import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const eventAnalysisStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            boxShadow: "0px 4px 10px rgba(110, 102, 102, 0.2)",
            padding: "20px",
            marginTop: "20px",
            marginRight: "30px",
            borderRadius: "0px",
        },
        margin: { marginBottom: "20px" },
        batchInfo: { paddingLeft: "10px" },
        batchTitle: { marginBottom: "10px" },
        errorText: {
            color: "rgba(223, 80, 49, 1)",
            marginBottom: "15px",
        },
        title: { fontWeight: 600, fontSize: "18px" },
        text: {
            color: "#181818",
            lineHeight: "120%",
            fontSize: "18px",
        },
        messageText: {
            fontSize: "18px",
        },
        highlightedText: {
            fontWeight: 600,
        },
        customTitle: {
            color: "#525252",
            fontWeight: 500,
            fontSize: "18px",
        },
        container: {
            marginBottom: "10px",
            marginTop: "30px",
        },
        mainTitle: {
            color: "#181818",
            fontWeight: 500,
            fontSize: "32px",
            marginBottom: "12px",
        },
        subTitle: {
            color: "#000000",
        },
    })
);
